import PropTypes from 'prop-types'
import Link from 'components/Link'
import { PAGE_NAVIGATION_ITEMS_TYPE } from 'types'

const TableOfContents = ({ title, navItems }) => (
  <nav>
    <h2 className='mc-text-h4'>{title}</h2>
    <ul className='mc-mt-3'>
      {navItems
        .filter((item) => item.label && item.path)
        .map((navItem) => (
          <li className='mc-mt-3' key={navItem.label}>
            <Link className='mc-text--link' href={navItem.path} isBasic>
              {navItem.label}
            </Link>
          </li>
        ))}
    </ul>
  </nav>
)

TableOfContents.propTypes = {
  title: PropTypes.string.isRequired,
  navItems: PAGE_NAVIGATION_ITEMS_TYPE,
}

export default TableOfContents
